export default __webpack_public_path__ + "static/media/newSet2-3-min.d2e81d44.png";